export default __webpack_public_path__ + "static/media/cross.e5105102.svg";